__turbopack_context__.v({
  "inlineLink": "dsharpDesignSystem-module__IAjEnG__inlineLink",
  "metaBlock": "dsharpDesignSystem-module__IAjEnG__metaBlock",
  "metaGrid": "dsharpDesignSystem-module__IAjEnG__metaGrid",
  "metaLabel": "dsharpDesignSystem-module__IAjEnG__metaLabel",
  "metaLeft": "dsharpDesignSystem-module__IAjEnG__metaLeft",
  "metaOverview": "dsharpDesignSystem-module__IAjEnG__metaOverview",
  "metaRight": "dsharpDesignSystem-module__IAjEnG__metaRight",
  "metaSection": "dsharpDesignSystem-module__IAjEnG__metaSection",
  "metaText": "dsharpDesignSystem-module__IAjEnG__metaText",
  "metaTools": "dsharpDesignSystem-module__IAjEnG__metaTools",
  "page": "dsharpDesignSystem-module__IAjEnG__page",
  "specimenCaption": "dsharpDesignSystem-module__IAjEnG__specimenCaption",
  "specimenFigure": "dsharpDesignSystem-module__IAjEnG__specimenFigure",
  "specimenSvg": "dsharpDesignSystem-module__IAjEnG__specimenSvg",
});
